const HOUSE_PART_REGEXP = /(д(ом)?|уч(асток)?|стр?)\.?\s/i;

/**
 * Разделяет адрес на уличную часть и часть с домом.
 *
 * Считает, что дом находится в последнем сегменте адреса после последней запятой.
 * Если в этом сегменте найден маркер дома, участка или строения
 * (например "д", "дом", "уч", "участок", "стр"),
 * дополнительно выделяет номер дома без этого маркера.
 *
 * Если маркер дома не найден, возвращает весь адрес как street.
 *
 * Примеры:
 * - "Москва, ул Ленина, д 10" -> { street: "Москва, ул Ленина", house: "д 10", houseNumber: "10" }
 * - "Самара, Московское шоссе" -> { street: "Самара, Московское шоссе", house: "" }
 */
export const getStreetAndHouseFromAddress = (address?: string) => {
  const normalizedAddress = address || '';
  const [street = '', house = ''] = normalizedAddress.split(/,\s?(?=[^,]*$)/);

  const housePartMatch = HOUSE_PART_REGEXP.exec(house);
  const housePrefix = housePartMatch?.[0];

  if (!housePrefix) {
    return {
      street: normalizedAddress,
      house: '',
    };
  }

  const houseNumber = house.split(housePrefix)?.[1];

  return {
    street,
    house,
    houseNumber,
  };
};
